import React, { useState } from 'react';
import ExampleModal from "./ExampleModal"
import banner1 from '../../assets/meeting2.png';
import footerlogo from '../../assets/logo.png';
import appstore from '../../assets/Appstore.png';
import googleplay from '../../assets/Googleplay.png';
import {
    BrowserRouter as Router, Switch, Route, Link , useHistory
  } from "react-router-dom";

function Home(props) {   
  
    var history = useHistory();
    const onNavigate = (o) => {
      history.push(o)
    }
    return (
        <div>
          {/* Intro banner */}
          <div className="banner-container">
            <img src={banner1} style={{width: "100%", height: "100%"}} alt="Banner Image"></img>
            <div className="banner-top-left ">
              <div className="row">
                <div className="col-md-12">
                  <div className="banner-headline">
                    <div className="banner-dark-overlay">
                      <strong>Online Talent Assessment</strong>
                      <br></br><span>Select and reach out to the best talent 
                        remotely across the country.</span>
                    </div>
                  </div>
                </div>
                </div>
              <div className="row mg-t-50">
                <div className="col-md-12">
                  <div className="intro-banner-search-form mg-t-50" >
                    <div className="intro-search-field with-label">
                      <label className="field-title">Where?</label>
                      <div className="input-with-icon">
                        <input placeholder="Job Location" type="text"></input>
                        <i className="fas fa-map-marker-alt "></i>                        
                      </div>
                    </div>
                    <div className="intro-search-field with-label">
                      <label className="field-title">What you need done?</label>
                      <input placeholder="e.g. build me a website"></input>                      
                    </div>
                    <div className="intro-search-field" style={{borderRight:'0px'}}>
                      <div className="btn-group bootstrap-select show-tick default">
                        <button className="btn dropdown-toggle bs-placeholder btn-default">
                          <span className="filter-option pull-left">All Categories</span>
                          &nbsp;
                          <span className="bs-caret">
                            <span className="caret"></span>
                          </span>
                        </button>
                      </div>                    
                    </div>
                    <div className="intro-search-button">
                      <button className="button">Search
                      </button>
                    </div>
                  </div>
                </div> 
              </div>

              <div className="row">
                <div className="col-md-12">
                  <ul className="intro-stats mg-t-45">
                    <li>
                      <strong >469</strong>
                      <span>Profiles</span>
                    </li>
                    <li>
                      <strong >152</strong>
                      <span>Skills</span>
                    </li>
                    <li>
                      <strong >343</strong>
                      <span>Jobs</span>
                    </li>
                  </ul>
              </div> 
              </div>
              
              
            </div>
          </div>
          <div className="mg-t-30 home-section mg-b-30">
          <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="home-headline center mg-b-15">
                <h3>Popular Skill Categories</h3>
              </div>  
              <div className="categories-container"> 
                <a className="category-box" >
                  <div className="category-box-icon"> 
                    <i className="far fa-file-code "></i>
                  </div>
                  <div className="category-box-counter">612</div>
                  <div className="category-box-content">                   
                    <h3>Web & Software Dev</h3>
                    <p>Software Engineer, Web / Mobile Developer &amp; More</p>
                  </div>
                </a>
                <a className="category-box" >
                  <div className="category-box-icon"> 
                    <i className="fa fa-chart-line"></i>
                  </div>
                  <div className="category-box-counter">113</div>
                  <div className="category-box-content">                   
                    <h3>Data Science & Analytics</h3>
                    <p>Software Engineer, Web / Mobile Developer &amp; More</p>
                  </div>
                </a>
                <a className="category-box" >
                  <div className="category-box-icon"> 
                    <i className="fa fa-chart-pie"></i>
                  </div>
                  <div className="category-box-counter">186</div>
                  <div className="category-box-content">                   
                    <h3>Sales & Marketing</h3>
                    <p>Software Engineer, Web / Mobile Developer &amp; More</p>
                  </div>
                </a>
                <a className="category-box" >
                  <div className="category-box-icon"> 
                    <i className="fa fa-briefcase"></i>
                  </div>
                  <div className="category-box-counter">298</div>
                  <div className="category-box-content">                   
                    <h3>Accounting & Audits</h3>
                    <p>Software Engineer, Web / Mobile Developer &amp; More</p>
                  </div>
                </a>
                <a className="category-box" >
                  <div className="category-box-icon"> 
                    <i className="fa fa-bezier-curve "></i>
                  </div>
                  <div className="category-box-counter">549</div>
                  <div className="category-box-content">                   
                    <h3>Graphics & Design</h3>
                    <p>Software Engineer, Web / Mobile Developer &amp; More</p>
                  </div>
                </a>
                <a className="category-box" >
                  <div className="category-box-icon"> 
                    <i className="fa fa-bullhorn "></i>
                  </div>
                  <div className="category-box-counter">873</div>
                  <div className="category-box-content">                   
                    <h3>Digital Marketing </h3>
                    <p>Software Engineer, Web / Mobile Developer &amp; More</p>
                  </div>
                </a>
                <a className="category-box" >
                  <div className="category-box-icon"> 
                    <i className="fa fa-graduation-cap "></i>
                  </div>
                  <div className="category-box-counter">129</div>
                  <div className="category-box-content">                   
                    <h3>Education & Training</h3>
                    <p>Software Engineer, Web / Mobile Developer &amp; More</p>
                  </div>
                </a>
                <a className="category-box" >
                  <div className="category-box-icon"> 
                    <i className="fa fa-pencil-alt "></i>
                  </div>
                  <div className="category-box-counter">445</div>
                  <div className="category-box-content">                   
                    <h3>Writing & Translations</h3>
                    <p>Software Engineer, Web / Mobile Developer &amp; More</p>
                  </div>
                </a>
              </div>          
            </div>
          </div>
          </div>
          </div>

          <div className="home-footer">
            <div className="home-footer-top-section">
            <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="home-footer-row-container">
                  <div >
                    <div className="home-footer-logo">
                        <img src={footerlogo} ></img>seeker
                      </div>
                  </div>
                  <div className="home-footer-row-right">
                    <div className="home-footer-logo">
                      <i className="fab fa-facebook-square pd-r-15 "></i>
                      <i className="fab fa-twitter-square pd-r-15 "></i>
                      <i className="fab fa-linkedin "></i>                              
                    </div>                    
                  </div>
                  <div className="home-footer-row-right pd-r-40">
                    <div className="home-footer-logo">
                    <img src={appstore} style={{width: '130px', height:'40px'}} className="pd-r-30"></img>
                    <img src={googleplay} style={{width: '120px'}} ></img>                            
                    </div>                    
                  </div>
                </div>
              </div>
              </div>
            </div>
            </div>

            <div className="home-footer-middle-section">
            <div className="container">
            <div className="row">
              <div className="col-md-2">
                <div className="home-footer-links">
                  <h3> For Aspirants</h3>
                  <ul>
                    <li><a><span onClick={() => onNavigate("profile")}>Create Profile</span></a></li>
                    <li><a><span>Assess Skills</span></a></li>
                    <li><a><span>Apply for Jobs</span></a></li>
                    <li><a><span>Browse Jobs</span></a></li>
                    <li><a><span>Job Watchlist</span></a></li>
                  </ul>
                </div>
              </div>
              <div className="col-md-2">
                <div className="home-footer-links">
                  <h3> For Employers</h3>
                  <ul>
                    <li><a><span>Select Aspirants</span></a></li>
                    <li><a><span>Post Jobs</span></a></li>
                    <li><a><span>Feature Jobs</span></a></li>
                    <li><a><span>Aspirant Watchlist</span></a></li>
                  </ul>
                </div>
              </div>
              <div className="col-md-2">
                <div className="home-footer-links">
                  <h3> Helpful Links</h3>
                  <ul>
                    <li><a><span>Contact Us</span></a></li>
                    <li><a><span>Privacy Policy</span></a></li>
                    <li><a><span>Terms of Use</span></a></li>
                    <li><a><span onClick={() => onNavigate("about")}>About Us</span></a></li>
                  </ul>
                </div>
              </div>              
              <div className="col-md-2">
                <div className="home-footer-links">
                  <h3> Account</h3>
                  <ul>
                    <li><a><span>Register/Log In</span></a></li>
                    <li><a><span>My Account</span></a></li>                    
                  </ul>
                </div>
              </div>
              <div className="col-md-4">
                <div className="home-footer-links">
                  <h3> <i className="fas fa-map-marker-alt pd-r-15"></i>Sign Up For a Newsletter </h3>
                  <p>Weekly breaking news, analysis and cutting edge advices on job searching.</p>
                  <form className="newsletter">
                    <input type="text" placeholder="Enter your email address"></input>
                    <button className="btn btn-newsletter btn-primary-active mg-l-15" style={{marginBottom:'16px'}}>
                      <i className="fas fa-arrow-right"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
            </div>
            </div>
          </div>
        </div>
    );
  }

export default Home